import { ProductComparisonBar } from "./productComparisonBar";

const ProductComparisonBarDefault = () => {
    return (
        <ProductComparisonBar>
            <ProductComparisonBar.Trigger />
            <ProductComparisonBar.Wrapper>
                <ProductComparisonBar.Content>
                    <ProductComparisonBar.Content.HeaderButton />
                    <ProductComparisonBar.Content.ClearButton />
                    <ProductComparisonBar.Content.Products />
                    <ProductComparisonBar.Content.CompareButton />
                </ProductComparisonBar.Content>
            </ProductComparisonBar.Wrapper>
        </ProductComparisonBar>
    );
};

export { ProductComparisonBarDefault };
